<template>
  <v-app>
    <!-- <apexcharts type="bar" :options="chartOptions" :series="series"></apexcharts> -->
      <v-toolbar>
        <v-spacer></v-spacer>
        <v-toolbar-title><h4>{{ client.CLIENTNAME }} - VINEYARDS</h4></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <v-btn slot="activator" color="primary" class="row end-xs">New Vineyard</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">VINEYARD INFO</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 d-flex>
                   <v-autocomplete v-on:change="updateAppellation"
                      :value="editedItem.appellation"
                      :items="appellations"
                      item-text="name"
                      label-text="name"
                      label="Appellation"
                      outline
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 d-flex>
                   <v-autocomplete v-on:change="updateRegion"
                      :value="editedItem.region"
                      :items="regions"
                      item-text="name"
                      label-text="name"
                      label="Regions"
                      outline
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.gateCode" label="Gate Code"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field v-model="editedItem.applemoth" label="Apple Moth Cert"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-checkbox color="primary" v-model="editedItem.organic" label="Organic" @change="organicStateChanged">
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-checkbox color="primary" v-model="editedItem.bioDynamic" label="BioDynamic" @change="bioDynamicStateChanged">
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="close">Cancel</v-btn>
              <v-btn color="primary" flat @click.native="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
        </v-card>
        <v-data-table
            :headers='headers'
            :items='vineyards'
            :search='search'
            v-model='selected'
            item-key='id'
            hide-actions
            class="elevation-1"
            >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item)">
                <td width=50px @click="rowClicked(props.item)"><v-icon :color="getColor('SCP')">fa-leaf</v-icon></td>
                <td width=250px>{{ props.item.name }}</td>
                <td width=25px>{{ props.item.tonnageTotal }}</td>
                <td>{{ props.item.appellation }}</td>
                <td>{{ props.item.region }}</td>
                <td width=25px>{{ props.item.gateCode }}</td>
                <td width=25px>{{ props.item.applemoth }}</td>
                <td width=25px style="text-align: center">
                  <v-checkbox hide-details v-model="props.item.isOrganic" readonly></v-checkbox>
                </td>
                <td width=25px style="text-align: center">
                  <v-checkbox hide-details v-model="props.item.isBioDynamic" readonly></v-checkbox>
                </td>
                <td width=50px class="justify-end">
                  <v-icon
                    small
                    @click="deleteItem(props.item)"
                  >
                    delete
                  </v-icon>
                </td>
              </tr>
            </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        </v-data-table>
    </v-app>
</template>

<script>
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import myMixins from '../mixins/myMixins'

export default {
  components: {
    apexcharts: VueApexCharts
  },
  data () {
    return {
      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        display: false,
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: []
        },
        yaxis: {

        },
        tooltip: {

        }
      },
      series: [{
        data: []
      }],
      selected: [],
      showSuccessBanner: false,
      editedItem: {
        clientId: 0,
        organic: '',
        bioDynamic: '',
        name: '',
        appellation: '',
        gateCode: '',
        applemoth: '',
        region: ''
      },
      editedIndex: -1,
      dialog: false,
      search: '',
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Tonnage', value: 'tonnage', sortable: true },
        { text: 'Appellation', value: 'appellation', sortable: true },
        { text: 'Region', value: 'region', sortable: false },
        { text: 'Gate Code', value: 'gateCode', sortable: false },
        { text: 'Moth Cert', value: 'applemoth', sortable: false },
        { text: 'Org', value: 'organic', sortable: false },
        { text: 'Bio', value: 'bioDynamic', sortable: false },
        { text: '', value: 'edit', sortable: false },
        { text: '', value: 'delete', sortable: false }
      ]
    }
  },
  mixins: [myMixins],
  computed: {
    regions () {
      return this.$store.state.regions
    },
    vineyards () {
      return this.$store.state.vineyards
    },
    appellations () {
      return this.$store.state.appellations
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  methods: {
    updateAppellation (value) {
      this.editedItem.appellation = value
    },
    updateRegion (value) {
      this.editedItem.region = value
    },
    organicStateChanged (value) {
      if (value) {
        this.editedItem.organic = 'YES'
      } else {
        this.editedItem.organic = 'NO'
      }
    },
    bioDynamicStateChanged (value) {
      if (value) {
        this.editedItem.bioDynamic = 'YES'
      } else {
        this.editedItem.bioDynamic = 'NO'
      }
    },
    clicked (value) {
    },
    save () {
      if (this.editedIndex > -1) { // This is an edit
        Object.assign(this.$store.state.vineyards[this.editedIndex], this.editedItem)
        axios
          .put(process.env.VUE_APP_BACKEND+'locations/'+this.editedItem.id, this.editedItem)
          .then((response) => {
          })
      } else { // This is a new record
        this.editedItem.locationType = 'VINEYARD'
        this.editedItem.clientId = this.$store.state.client.clientid
        axios
          .post(process.env.VUE_APP_BACKEND+'locations', this.editedItem)
          .then((response) => {
            this.$store.commit('addVineyard', response.data.data)
          })
      }
      this.close()
    },
    editItem (item) {
      this.editedIndex = this.vineyards.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.$store.state.vineyards.indexOf(item)
      confirm('Are you sure you want to delete this item?') && this.$store.state.vineyards.splice(index, 1)
    },
    close () {
      this.dialog = false
      this.editedIndex = -1
    },
    updateLotOrganicStatus (lots) {
      this.$store.state.vineyards = []
      var categories = []
      var tonnage = []
      lots.forEach(element => {
        var item = element
        item.organic = (element.organic === 'YES')
        item.bioDynamic = (element.bioDynamic === 'YES')
        categories.push(element.name)
        tonnage.push(element.tonnageTotal)
        this.$store.state.vineyards.push(item)
      })
      this.chartOptions = {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: categories
        },
        yaxis: {

        },
        tooltip: {

        }
      }
      this.series = [{ data: tonnage }]
    }
  }
}
</script>
<style>
</style>
